import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { t } from "@redotech/redo-i18n";
import { PriceOption } from "@redotech/redo-return-core-common/condition-options";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  priceConditionFromModel,
  validatePriceCondition,
  type TotalPreDiscountPriceState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const TOTAL_PRE_DISCOUNT_PRICE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalPreDiscountPriceState>
  >,
): ConditionType<
  TotalPreDiscountPriceState,
  Condition.TotalPreDiscountPrice
> => ({
  name: CONDITION_NAMES[Condition.TOTAL_PRE_DISCOUNT_PRICE],
  description(state) {
    if (!state.priceOption) {
      return t(
        "The sum of the original prices before discounts for every item the customer is returning, this is the price listed on your website",
      );
    }
    switch (state.priceOption) {
      case PriceOption.LESS_THAN:
        return t(
          "The sum of the original prices before discounts for every item the customer is returning is less than {{value}}",
          {
            value: moneyFormat({
              amount: +state.amount,
              currency: DEFAULT_CURRENCY,
            }),
          },
        );
      case PriceOption.GREATER_THAN:
        return t(
          "The sum of the original prices before discounts for every item the customer is returning is greater than {{value}}",
          {
            value: moneyFormat({
              amount: +state.amount,
              currency: DEFAULT_CURRENCY,
            }),
          },
        );
      case PriceOption.EQUALS:
        return t(
          "The sum of the original prices before discounts for every item the customer is returning equals {{value}}",
          {
            value: moneyFormat({
              amount: +state.amount,
              currency: DEFAULT_CURRENCY,
            }),
          },
        );
      case PriceOption.CENTS_EQUALS:
        return t(
          "The sum of the original prices before discounts for every item the customer is returning has cents equal to {{value}}",
          {
            value: moneyFormat({
              amount: +state.amount,
              currency: DEFAULT_CURRENCY,
            }),
          },
        );
    }
  },
  Details(props: ConditionTypeDetailsProps<TotalPreDiscountPriceState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return priceConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.TOTAL_PRE_DISCOUNT_PRICE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return validatePriceCondition(state).valid;
  },
});
